module.exports = __webpack_public_path__ + "static/fibreconnected-5ee7eee7b08b005fae598a97dae9904a.svg";